webpackJsonp([41165524213704],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _componentsModule = __webpack_require__(6);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatesPage = function DatesPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: _componentsModule2.default.pagetitle },
	      'Deadline Dates'
	    ),
	    _react2.default.createElement(
	      'table',
	      null,
	      _react2.default.createElement(
	        'tbody',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'March 1'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Proposals for Special Sessions'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'March 6'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Notification of Acceptance for Special Session Proposals'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'April 25'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Submission of Regular and Special Session Papers'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'May 30'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Notification of Paper Acceptance'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'June 15'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Camera-ready papers due'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'June 22'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Submission of Abstract and Demo Papers'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            null,
	            'August 29\u201331'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Workshop Dates'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = DatesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dates-js-ed6f39f1bfa92f3b2805.js